import LikePostContextProvider from './LikePostContextProvider'
export { useLikePostContext } from './LikePostContextProvider'
export default LikePostContextProvider